import { defineMessages } from "react-intl";

export default defineMessages({
  submitButtonText: {
    id: "Payment.PaymentElement.submitButtonText",
    defaultMessage: "Submit",
  },
});
